module.exports = __webpack_public_path__ + "img/transfer3.ab1ddb5d.jpg";